window.site = (window.site || {});

/**
 * Init Mobile Menu related scripts
 * @class Site
 * @static
 */
site.BlogFilter = (function BlogFilter() {

  'use strict';

  /**
   * jQuery elements
   * @private
   */

  /**
   * Has the class been initialized?
   * @private
   */
  var inited = false;

  /**
   * Initializes the class.
   * @public
   */
  var init = function () {

    // Abort if already initialized
    if (inited) {
      return false;
    }

    inited = true;

    let $tabs = [].slice.call(document.querySelectorAll('.news .news-links.js-click .news-link'));
    let $containers = [].slice.call(document.querySelectorAll('.news .blog-listing.home'));
    let $btns = [].slice.call(document.querySelectorAll('.news .news-button.home'));
    let $currentURL = window.location.href;

    if ($tabs.length && $containers.length) {
      let $nextURL = $currentURL + '/publications?type=events';
      let articlesCount = $containers[1].getAttribute('data-count');

      if (articlesCount > 3) {
        $btns[0].style.display = "inline-block";
        $btns[0].href = $nextURL;
      } else {
        $btns[0].style.display = "none";
      }

      $tabs.forEach(($tab) => {
        $tab.addEventListener('click', () => {
          if (!$tab.classList.contains('is-active')) {
            let type = $tab.getAttribute('data-type');

            $tabs.forEach(($tabLoop) => {
              if ($tabLoop.classList.contains('is-active')) {
                $tabLoop.classList.remove('is-active');
              }
              else if ($tabLoop.getAttribute('data-type') == type) {
                $tabLoop.classList.add('is-active');
              }
            });

            $containers.forEach(($container) => {
              if ($container.classList.contains('is-active')) {
                $container.classList.remove('is-active');
              }
              else if ($container.getAttribute('data-type') == type) {
                $container.classList.add('is-active');
                let $nextURL = $currentURL + '/publications?type=' + type;
                let articlesCount = $container.getAttribute('data-count');

                if (articlesCount > 3) {
                  $btns[0].style.display = "inline-block";
                  $btns[0].href = $nextURL;
                } else {
                  $btns[0].style.display = "none";
                }
              }
            });
          }
        });
      });
    }

    return true;

  };

  // Expose public methods & properties
  return {
    init: init,
  };

}());
